import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { queryKeys } from "@/lib/queryClient";
import { getEvaluationRubrics } from "@/api/endpoints/maturity";

export function useGetEvaluationRubrics(
  categoryCode?: string,
  domainCode?: string
) {
  const key = domainCode || categoryCode || "";
  return useQuery({
    queryKey: queryKeys.maturity.rubrics(key),
    queryFn: () => getEvaluationRubrics(categoryCode, domainCode),
    staleTime: Infinity,
    enabled: !!(categoryCode || domainCode),
  });
}

export function usePrefetchEvaluationRubrics(domainCode?: string) {
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!domainCode) return;
    queryClient.prefetchQuery({
      queryKey: queryKeys.maturity.rubrics(domainCode),
      queryFn: () => getEvaluationRubrics(undefined, domainCode),
      staleTime: Infinity,
    });
  }, [queryClient, domainCode]);
}
